import PropTypes from 'prop-types'
import React from 'react'

import IconComponent from '../IconComponent/IconComponent'
import LoaderWrapperComponent from '../LoaderWrapperComponent/LoaderWrapperComponent'
import RichTextComponent from '../RichTextComponent/RichTextComponent'
import { ReadMore } from '../../../RoomUI/components/ReadMore/ReadMore'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'

import './WebinarInfoPanelComponent.scss'

const WebinarInfoPanelComponent = ({ theme = 'no' }) => {
  const { data: liveData, isLoading } = useLiveDataQuery()

  return (
    <div className={`webinar-info-panel-component ${theme}-theme`}>
      <LoaderWrapperComponent loading={isLoading}>
        {liveData && (
          <>
            <h3>{liveData.name}</h3>

            <div className="webinar-date">
              {theme === 'waiting-room' && (
                <IconComponent
                  name="date"
                  color="8d8e8d"
                  className="date-icon"
                />
              )}
              {liveData.primary_timezone_live_date__date} &nbsp;
              {liveData.primary_timezone_live_date__time} <br />
            </div>

            <ReadMore lines={3}>
              <RichTextComponent text={liveData.description_html} />
            </ReadMore>
          </>
        )}
      </LoaderWrapperComponent>
    </div>
  )
}

WebinarInfoPanelComponent.propTypes = {
  theme: PropTypes.oneOf(['waiting-room']),
}

// eslint-disable-next-line import-x/no-default-export
export default WebinarInfoPanelComponent
